import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NoteAcknowledgementsService } from "./note-acknowledgements.service";
import { Note } from "../shared/note.model";
import { NoteAcknowledgement } from "./note-acknowledgement.model";
import { AppStateService } from "../../core/services/app-state.service";
import { User } from "ng/src/app/users/shared/user.model";
import { LogService } from '../../logs/log.service';

@Component({
    selector: 'note-acknowledgements[note]',
    templateUrl: './note-acknowledgements.component.html',
    styleUrls: ['./note-acknowledgements.component.css']
})
export class NoteAcknowledgementsComponent implements OnInit {
	@Input() note!: Pick<Note, 'acknowledgements' | '_links'>;
	@Input() showTime = false;
	@Input() displayShowAllButton = true;
	
	@Input()
	get showAll() {
		return this._showAll;
	};
	set showAll(val) {
		this._showAll = val;
		this.showAllChange.emit(val);
	}
	
	@Output() showAllChange = new EventEmitter<boolean>();
	
	acknowledged = false;
	loading = false;
	showAcknowledgeButton =
		LogService.selectedLog?.role != 'READ' ||
		LogService.selectedLog.isWriteOnShiftRole;
	
	private _showAll = false;

	constructor(
		private cd: ChangeDetectorRef,
		private noteAckService: NoteAcknowledgementsService,
        private state: AppStateService
    ) { }

	get acknowledgements(): NoteAcknowledgement[] {
		return this.note?.acknowledgements || [];
    }

    get user(): User | undefined {
        return this.state.currentUser;
    }
	
	get count() {
		return this.note.acknowledgements.length - (this.acknowledged ? 1 : 0);
	}

    ngOnInit(): void {
        this.acknowledged = this.acknowledgements.findIndex(ack => ack.createdBy.id === this.user?.id) > -1;
    }
	
	belongsToMe(ack: NoteAcknowledgement) {
		return ack.createdBy.id === AppStateService.currentUser?.user?.id;
	}

    acknowledge() {
		this.loading = true;
		
        this.noteAckService.acknowledgeNote(this.note)
            .subscribe(res => {
                this.acknowledged = true;
				this.note.acknowledgements = res._embedded.note.acknowledgements;
				
				this.cd.detectChanges();
			})
			.add(() => this.loading = false);
    }
}